import 'zone.js';
import { enableProdMode } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import { bootstrapApplication } from '@angular/platform-browser';
import hr from '@angular/common/locales/hr';

import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

declare global {
  interface Window {
      _paq:any;
  }
}

if (environment.production) {
  enableProdMode();
}

registerLocaleData(hr);

document.body.classList.add(environment.page);

bootstrapApplication(AppComponent, appConfig)
  .catch(err => console.error(err));